export async function getInvalidEntry(files: File[]) {
  const Zip = (await import('adm-zip')).default
  for (const file of files) {
    const zip = new Zip(Buffer.from(await file.arrayBuffer()))
    const entries = zip.getEntries()
    const entry = entries.find((entry) => entry.name.match(/\uFFFD/g))
    if (entry) return { entry, file }
  }
}
